import { createPortal } from 'react-dom';
import './ClipboardSharePrompt.css';

/**
 * Surfaced when a SUSU share link is found on the clipboard (or pasted into the
 * app) rather than opened as a URL — the recipient copied the link instead of
 * clicking it, which is what happens whenever it arrives by DM.
 *
 * Deliberately an offer, not an auto-claim: nothing enters the user's closet
 * until they say so.
 */
const ClipboardSharePrompt = ({ isOpen, share, onAccept, onDismiss }) => {
  if (!isOpen || !share?.info) return null;

  const { info } = share;
  const sharerName = info.sharer?.displayName || info.sharer?.username || 'A friend';
  const clothes = info.clothingItems || [];
  const looks = info.looks || [];
  const previews = [...looks, ...clothes].slice(0, 4);
  const total = clothes.length + looks.length;

  return createPortal(
    <div className="clipboard-share-prompt" role="status">
      <div className="clipboard-share-thumbs">
        {previews.map((item, idx) => (
          <div className="clipboard-share-thumb" key={item.id || idx}>
            {item.imageUrl ? <img src={item.imageUrl} alt="" /> : <span>👕</span>}
          </div>
        ))}
      </div>

      <div className="clipboard-share-body">
        <div className="clipboard-share-title">
          {sharerName} shared {total > 0 ? `${total} item${total === 1 ? '' : 's'}` : 'items'} with you
        </div>
        <div className="clipboard-share-subtitle">
          {info.title ? `From “${info.title}” · ` : ''}Link found on your clipboard
        </div>
      </div>

      <div className="clipboard-share-actions">
        <button className="clipboard-share-accept" onClick={onAccept}>
          Add to my closet
        </button>
        <button className="clipboard-share-dismiss" onClick={onDismiss} aria-label="Dismiss">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ClipboardSharePrompt;
